// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
//import './index.css';
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/notifications/styles.css';
import 'mantine-react-table/styles.css'; // Add this line!
import './mantine-overrides.css'; // must come after Mantine's own styles

import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import msalInstance from './msalInstance'; // Import the shared MSAL instance
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { ApolloProvider } from "@apollo/client";
import client from "./services/Apollo"; // Adjust the path if necessary
import { loadErrorMessages, loadDevMessages } from "@apollo/client/dev";

const root = ReactDOM.createRoot(document.getElementById('root'));

const mtheme = createTheme({
  colors: {
    // You can add custom colors here if needed
 
  },
  other: {
    // Custom background colors for light mode
    lightBackground: '#f8f9fa', // Light gray instead of white
  },
  components: {
    AppShell: {
      styles: (theme) => ({
        main: {
          backgroundColor: theme.colorScheme === 'light' ? '#f8f9fa' : undefined,
        },
      }),
    },
    Paper: {
      styles: (theme) => ({
        root: {
          backgroundColor: theme.colorScheme === 'light' ? '#ffffff' : undefined,
          // Keep Paper components white for contrast against gray background
        },
      }),
    },
  },
});

loadDevMessages();    // Loads development-specific error messages
loadErrorMessages();  // Loads all error messages

// Custom theme with light gray background instead of white
const theme = createTheme({
  colors: {
    // You can add custom colors here if needed
  },
  other: {
    // Custom background colors for light mode
    lightBackground: '#f8f9fa', // Light gray instead of white
  },
  components: {
    AppShell: {
      styles: (theme) => ({
        main: {
          backgroundColor: theme.colorScheme === 'light' ? '#f8f9fa' : undefined,
        },
      }),
    },
    Paper: {
      styles: (theme) => ({
        root: {
          backgroundColor: theme.colorScheme === 'light' ? '#ffffff' : undefined,
          // Keep Paper components white for contrast against gray background
        },
      }),
    },
  },
});

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <ApolloProvider client={client}>
        <MantineProvider theme={theme} defaultColorScheme="auto">
          <Notifications position="bottom-right" autoClose={3000} />
          <App />
        </MantineProvider>
      </ApolloProvider>
    </MsalProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();